import type { Tour } from '../types/tour';

type TourListItem = Pick<Tour, 'id' | 'name' | 'headliner'>;

export const toursMockData: TourListItem[] = [
  { id: 'tour-001', name: 'Zinadelphia', headliner: 'Jason Isbell' },
  { id: 'tour-002', name: 'Zinadelphia 22', headliner: 'Celine Dion' },
  { id: 'tour-003', name: 'Zimmer90', headliner: 'Zimmer 90' },
  { id: 'tour-004', name: 'Zakir Khan: Papa Yaar', headliner: 'Zakir Khan' },
  { id: 'tour-005', name: 'Zach Loizou', headliner: 'Zach Loizou' },
  {
    id: 'tour-006',
    name: 'Zach Bryan June 2025 Ireland',
    headliner: 'Zach Bryan',
  },
  { id: 'tour-007', name: 'Yungblud', headliner: 'Yungblud' },
  { id: 'tour-008', name: 'Yungblud', headliner: 'Yungblud' },
  { id: 'tour-009', name: 'XYZ TEST', headliner: null },
  { id: 'tour-010', name: 'XYZ TEST', headliner: null },
  { id: 'tour-011', name: 'xyz test', headliner: null },
  {
    id: 'tour-012',
    name: 'Will Young & Beverley Knight - War Tour',
    headliner: 'Will Young',
  },
  { id: 'tour-013', name: 'Will Smith', headliner: 'Will Smith' },
  {
    id: 'tour-014',
    name: 'Will Owen - Edinburgh Fringe 2025',
    headliner: 'Will Owen',
  },
  {
    id: 'tour-015',
    name: 'Willow Smith - Spring Tour 2025',
    headliner: 'Willow Smith',
  },
];
